import React, { useContext, useEffect } from "react";
import "./_style.scss";
import { Box, Typography } from "@mui/material";
import { GlobalContext } from "../../../context/globalContext";
import { TkRouteContext } from "../../../context/tkRouteContext";
import { BusinessContext } from "../../../context/businessContext";

const Error401Page = () => {
  const { setState } = useContext(GlobalContext);
  const { setState: setBusinessState } = useContext(BusinessContext);
  const { setState: setRouterState } = useContext(TkRouteContext);

  useEffect(() => {
    setState({});

    setBusinessState({});
  
    setRouterState({
      routerList: [],
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="tkErrorPage">
      <h1>認証エラー</h1>
      <Typography className="errorText">
        ログイン画面より再度ログインしてください。
      </Typography>
    </Box>
  );
};

export default Error401Page;
